import Api from '@/services/Api'

const HEADERURL = 'cxc/abonos/';
const ACTION_ELIMINAR_DETALLE = 'eliminar_detalle';
const ACTION_APLICAR_CARGO = 'aplicar_cargo';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';
const ACTION_AGREGAR_PAGO = 'agregar_pago';
const ACTION_AGREGAR_CONTABILIZACION = 'agregar_contabilizacion'

export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params,


        });

    },

    getById(codigo) {

        return Api().get(`${HEADERURL}${codigo}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },

    agregar_pago(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_AGREGAR_PAGO}/`, params);

    },

    agregar_contabilizacion(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_AGREGAR_CONTABILIZACION}/`, params);

    },

    eliminar_detalle(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ELIMINAR_DETALLE}/`, params);

    },

    aplicar_cargo(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_APLICAR_CARGO}/`, params);

    },

    abrir(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ABRIR}/`);

    },

    cerrar(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_CERRAR}/`);

    },

    anular(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ANULAR}/`);

    },


}